import { render, staticRenderFns } from "./LoginComponent.vue?vue&type=template&id=1d8407d6&"
import script from "./LoginComponent.vue?vue&type=script&lang=ts&"
export * from "./LoginComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports